module Meevo.Plugins.MeevoMessengerSettings {


    export class MeevoMessengerHelperService {
        constructor() {
        }

        public static getSectionNameFromConvo(convoInput: string): string {
            let section = '';
            switch (convoInput  ) {
                case "smssettings":
                    section = "SECTION_TWO_WAY_SMS";
                    break;
                default:
                    section = "SECTION_TEXTEL";
            }

            return section
        }
    }
}